import { render, staticRenderFns } from "./HomeMenu.vue?vue&type=template&id=3e9c961e&scoped=true"
import script from "./HomeMenu.vue?vue&type=script&lang=js"
export * from "./HomeMenu.vue?vue&type=script&lang=js"
import style0 from "./HomeMenu.vue?vue&type=style&index=0&id=3e9c961e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9c961e",
  null
  
)

export default component.exports